import { FC, useEffect } from 'react';

import { useModalContext } from 'utils/contexts/modal';

import { IntegrationsContext } from './IntegrationContext';
import { useLoginContext } from './LoginContext';
import { useGetIntegrations } from '../hooks/useGetIntegrations';
import { useAddIntegration } from '../hooks/useAddIntegration';
import { useDeleteIntegration } from '../hooks/useDeleteIntegration';
import { MovableInkModal } from '../constants';
import { MovableInkModalState } from '../types';

export const IntegrationsContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { authCode, authReset } = useLoginContext();
  const { showModal } = useModalContext<MovableInkModalState>();

  const {
    data: integrations = [],
    isLoading: isFetchingIntegrations,
    refetch: refetchIntegrations,
  } = useGetIntegrations();

  const { addIntegration, isLoading: isAdding } = useAddIntegration(() => {
    authReset();
    refetchIntegrations();
  });

  const { deleteIntegration, isLoading: isDeleting } = useDeleteIntegration(refetchIntegrations);

  useEffect(() => {
    if (authCode) {
      // prompt user to create integration
      showModal({
        modalId: MovableInkModal.Add,
        code: authCode,
      });
    }
  }, [authCode]);

  const value = {
    addIntegration,
    deleteIntegration,
    integrations,
    isAdding,
    isDeleting,
    isFetchingIntegrations,
    refetchIntegrations,
  };

  return <IntegrationsContext.Provider value={value}>{children}</IntegrationsContext.Provider>;
};
